import { CommonModule, NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { TrackingStep } from '@hub4b/models/server/tracking-step';
import { TrackingItemState } from 'src/app/models/server/tracking-item-state';

/**
 * Represente une étape du suivi de dossier.
 */
@Component({
    selector: 'app-tracking-step',
    templateUrl: './tracking-step.component.html',
    styleUrls: ['./tracking-step.component.scss'],
    imports: [NgClass, NgStyle, CommonModule, FontAwesomeModule]
})
export class TrackingStepComponent {
    /**
     * Icônes utilisées dans le template.
     */
    checkIcon = faCheckCircle;

    /**
     * Enumérations utilisées dans le template.
     */
    TrackingItemStateEnum = TrackingItemState;

    /**
     * Etape du suivi de dossier à afficher.
     */
    @Input()
    public trackingStep: TrackingStep;

    /**
     * Largeur du composant.
     */
    @Input()
    public width: string;

    constructor() {}
}
